// Progress bar state
const vzProgressBar = {
  ticking: false,
  elements: {
    progressElement: null,
    progressMeter: null,
    contentBegin: null,
    comments: null
  },
  dimensions: {
    contentBeginTop: 0,
    contentEndTop: 0,
    contentScrollDiff: 0
  }
};

/**
 * Cache DOM elements and calculate initial dimensions
 */
function vzCacheProgressElements() {
  vzProgressBar.elements.progressElement = document.querySelector('.progress[role="progressbar"]');

  if (!vzProgressBar.elements.progressElement) return false;

  vzProgressBar.elements.progressMeter = vzProgressBar.elements.progressElement.querySelector('.progress-meter');
  vzProgressBar.elements.contentBegin = document.querySelector('article > section');
  vzProgressBar.elements.comments = document.getElementById('comments');

  return !!(vzProgressBar.elements.contentBegin && vzProgressBar.elements.comments);
}

/**
 * Calculate dimensions for progress calculation
 */
function vzCalculateProgressDimensions() {
  const { contentBegin, comments } = vzProgressBar.elements;
  const windowHeight = document.documentElement.clientHeight;

  vzProgressBar.dimensions.contentBeginTop = contentBegin.offsetTop + contentBegin.offsetHeight + 20;
  vzProgressBar.dimensions.contentEndTop = comments.offsetTop - windowHeight;
  vzProgressBar.dimensions.contentScrollDiff = vzProgressBar.dimensions.contentEndTop - vzProgressBar.dimensions.contentBeginTop;
}

/**
 * Initialize progress bar and scroll event listener
 */
function progressBarInit() {
  if (!vzCacheProgressElements()) return;

  vzCalculateProgressDimensions();
  progressBarUpdate();

  // Scroll event listener with passive option
  document.addEventListener('scroll', handleProgressScroll, { passive: true });

  // Recalculate dimensions on resize
  window.addEventListener('resize', vzCalculateProgressDimensions, { passive: true });
}

/**
 * Scroll handler with requestAnimationFrame throttling
 */
function handleProgressScroll() {
  if (!vzProgressBar.ticking) {
    window.requestAnimationFrame(() => {
      progressBarUpdate();
      vzProgressBar.ticking = false;
    });

    vzProgressBar.ticking = true;
  }
}

/**
 * Update progressbar
 */
function progressBarUpdate() {
  const { progressElement, progressMeter } = vzProgressBar.elements;
  const { contentBeginTop, contentEndTop, contentScrollDiff } = vzProgressBar.dimensions;

  if (!progressElement || !progressMeter) return;

  const scrollY = window.pageYOffset || document.documentElement.scrollTop;

  let progress = 0;
  if (scrollY >= contentBeginTop && scrollY < contentEndTop) {
    progress = (scrollY - contentBeginTop) / contentScrollDiff;
  } else if (scrollY >= contentEndTop) {
    progress = 1;
  }
  progress *= 100;

  // Batch DOM writes
  requestAnimationFrame(() => {
    progressMeter.style.width = progress + '%';
    progressElement.setAttribute('aria-valuenow', Math.round(progress));
  });
}
